// extracted by mini-css-extract-plugin
module.exports = {"dots":"icons_dots__3YhYx","ellipsesHorizontal":"icons_ellipsesHorizontal__RqXfS","ellipsesVertical":"icons_ellipsesVertical__3kK_B"};